import { PuntoInspeccionViewModel } from 'src/app/components/_mantenimiento/general/puntosinspeccion/puntoinspeccion.types';
import { Tc } from 'src/app/components/core/_infrastructure/types/common';
import { TMedioTransporteExViewModel, TcTipoSolicitudExViewModel, TwSolicitudJerarquiaExViewModel } from '../datosbasicos/datosbasicosEx.types';
import { TReexportacionViewModel } from '../reexportacion/reexportacion.types';
import { TComentarioInspectorExViewModel } from '../seguimiento/seguimientoEx.types';

export class SolicitudProductosExViewModel {
    constructor() {}

    public Id: number;
    public IdEstadoSolicitudEx = 0;
    public IdTipoSolicitudEx = 0;
    public IdPais: number | null = null;
    public EsPrevia: boolean;
    public CodigoSolicitud: string;
    public IdEstadoSolicitudExDescripcion: string;
    public IdTipoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    //public FechaLlegada: Date;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;

    public TProductoSolicitudExCollection: TProductoSolicitudExViewModel[];
    public TSolicitudEquipamientoExCollection: EquipamientoExViewModel[];
    public TPuntoInspeccion: PuntoInspeccionViewModel;

    public TMedioTransporteEx: TMedioTransporteExViewModel;
    public TcTipoSolicitudEx: TcTipoSolicitudExViewModel;
    public TcEstadoSolicitudEx: Tc;
    public TwTcEstadoCertificadoFitoEx: Tc;
    public TwEmbalajesExCollection: TwEmbalajesExViewModel[];
    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
    public TReexportacionEx: TReexportacionViewModel;
    public TComentarioInspectorExCollection: TComentarioInspectorExViewModel[];

    //RECHAZOS
    //public TwInspeccionRechazo: TwInspeccionRechazoViewModel;
    //public TSolicitudMedidaRechazoCollection: TwSolicitudMedidaRechazoViewModel[];
    //public TSolicitudMotivoRechazoCollection: TwSolicitudMotivoRechazoViewModel[];
}

export class TwEmbalajesExViewModel {
    public Id: number;
    public IdSolicitudEx: number;
    public IdTaric: number;
    public IdTaricEmbalajeDescripcion: string;
    public IdEppo: number;
    public IdEppoEmbalajeDescripcion: string;
    public IdUnidad: number;
    public IdUnidadEmbalajeDescripcion: string;
    public IdPais: number;
    public IdPaisEmbalajeDescripcion: string;
    public Recuento: number;
    public IdEstadoSolicitudEx: number;
    public Codigo: string;
    public EsPrevia: boolean;
    public IdTipoSolicitudExDescripcion: string;
    public IdEstadoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    public MuestraLaboratorio: boolean;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;

    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
}

export class TProductoSolicitudExViewModel {
    public Id: number;
    public IdSolicitudEx: number;
    public CodigoTaric: string;
    public CodigoEppo: string;
    public IdEspecie: number;
    public IdBotanicaDescripcion: string;
    public IdPais: number;
    public IdPaisDescripcion: string;
    public IdProvincia: number | null;
    public NombreComun: string;
    public IdTaricProductoNombreCientificoNombreComun: string;
    public IdGrupo: number;
    //public IdGrupoDescripcion: string;
    public IdForma: number;
    public IdFormaDescripcion: string;
    public EspecieSinEppo: boolean;
    public MarcasBulto: string;
    public NumeroBulto: number | null;
    public Peso: number;
    public Volumen: number | null;
    public Nrc: string;
    public Unidades: number | null;
    public IdTipoBulto: number | null;
    public IsLevante: boolean;
    public ConCorteza: boolean;
    public IdTipoSolicitudEx: number;
    public IdTipoSolicitudExDescripcion: string;
    public IdEstadoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    //para grid predua
    public Grupo: string;
    public IdEstadoSolicitudEx: number;
    public Codigo: string;
    public EsPrevia: boolean;
    public DeAtestacion = false;
    public MuestraLaboratorio: boolean;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;

    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
}

//export class MatriculaPrecintoItemResultViewModel extends PagingResultsViewModel {

//    public ResultList: EquipamientoExViewModel[];
//}

export class EquipamientoExViewModel {
    public Id: number;
    public IdSolicitudEx: number;
    public Matricula: string;
    public Inspeccion: boolean;
    public Precinto: string;
}
